"use strict";

module.exports = "\n<svg class=\"bvp-icon pause\" viewBox=\"0 0 14 22\">\n  <g transform=\"translate(-23 -19)\" fill=\"#FFF\" fill-rule=\"evenodd\">\n    <rect x=\"23\" y=\"19\" width=\"3\" height=\"22\" rx=\"1.5\"/>\n    <rect x=\"34\" y=\"19\" width=\"3\" height=\"22\" rx=\"1.5\"/>\n  </g>\n</svg>\n";